import React from 'react';
import './header.scss';
import classNames from "classnames";
import TechIcon from "assets/icon/TechIcon";
import useLang from "hook/useLang";
import { LazyImage } from "../../component";
import mrEstateNotBook from "../../assets/image/mrestate-intro-notebook.png";
function HeaderLabels(_a) {
    var homePage = _a.homePage, techPage = _a.techPage, mediaPage = _a.mediaPage, worksPage = _a.worksPage, servicesPage = _a.servicesPage, mrEstateInfoPage = _a.mrEstateInfoPage, mrEstateIntroPage = _a.mrEstateIntroPage, mrEstateFeaturesPage = _a.mrEstateFeaturesPage, mrEstateMonetizationPage = _a.mrEstateMonetizationPage, aboutUs = _a.aboutUs;
    var lang = useLang();
    var main = classNames({
        'relative sizeScreen': true,
        'flex items-center justify-center headerLabel': homePage || worksPage || aboutUs || mrEstateIntroPage,
        'flex items-center headerLabel': techPage || servicesPage || mediaPage || mrEstateInfoPage || mrEstateFeaturesPage || mrEstateMonetizationPage,
    });
    var labels = function () {
        if (homePage) {
            return (React.createElement("h1", { className: 'text-5xl font-bold text-white' }, lang.file.header.home.title));
        }
        else if (techPage) {
            return (React.createElement(React.Fragment, null,
                React.createElement("h1", { className: 'HeaderTechLabel' }, lang.file.header.tech.title),
                React.createElement("div", { className: 'absolute bottom-0 sm:rtl:left-5 rtl:left-0 sm:ltr:right-5 ltr:right-0' },
                    React.createElement(TechIcon, { className: 'headerTechIcon' }))));
        }
        else if (mediaPage) {
            return (React.createElement("div", { className: 'relative py-10' },
                React.createElement("h1", { className: 'HeaderMediaLabel' }, lang.file.header.media.title),
                React.createElement("a", { href: '#ourWorks' },
                    React.createElement("p", { className: 'text-17 text-white absolute bottom-0 sm:ltr:left-2 ltr:left-0 sm:rtl:right-9 rtl:right-0' }, lang.file.header.media.text))));
        }
        else if (worksPage) {
            return (React.createElement("div", { className: 'my-10' },
                React.createElement("h1", { className: 'headerWorksTitle' }, lang.file.header.works.title),
                React.createElement("p", { className: 'text-20 font-normal leading-7 mt-8 whitespace-pre-wrap break-word' }, lang.file.header.works.text)));
        }
        else if (servicesPage) {
            return (React.createElement("div", { className: 'my-10' },
                React.createElement("h1", { className: 'headerServicesTitle' }, lang.file.header.services.title),
                React.createElement("p", { className: 'text-20 font-normal leading-7 mt-8 text-white whitespace-pre-wrap break-word' }, lang.file.header.services.text)));
        }
        else if (mrEstateInfoPage) {
            return (React.createElement("div", { className: 'w-full h-full flex lg:flex-row lg:justify-between flex-col-reverse items-center lg:mt-48 mt-24 relative' },
                React.createElement("div", { className: 'my-10 lg:w-2/5 w-full flex flex-col items-center' },
                    React.createElement("h1", { className: 'headerMrEstateInfoTitle text-mrestate' }, lang.file.header.mrEstateInfo.title),
                    React.createElement("p", { className: 'sm:text-18 text-16 font-normal leading-7 my-8 text-black whitespace-pre-wrap break-word text-justify' }, lang.file.header.mrEstateInfo.text),
                    React.createElement("a", { href: 'https://mrestate.ir/', className: 'text-white bg-mrestate px-10 py-2 rounded-lg' }, lang.file.header.mrEstateInfo.btn)),
                React.createElement(LazyImage, { className: 'headerMrEstateInfoImage', alt: 'mrestate', defaultImage: mrEstateNotBook, dataSrc: mrEstateNotBook, noScriptSrc: mrEstateNotBook })));
        }
        else if (mrEstateIntroPage) {
            return (React.createElement("div", { className: 'my-10' },
                React.createElement("h1", { className: 'headerWorksTitle' }, lang.file.header.mrEstateIntro.title),
                React.createElement("p", { className: 'text-20 font-normal leading-7 mt-8 whitespace-pre-wrap break-word' }, lang.file.header.mrEstateIntro.text)));
        }
        else if (mrEstateFeaturesPage) {
            return (React.createElement(React.Fragment, null,
                React.createElement("h1", { className: 'HeaderTechLabel' }, lang.file.header.mrEstateFeatures.title)));
        }
        else if (mrEstateMonetizationPage) {
            return (React.createElement("div", { className: 'my-10' },
                React.createElement("h1", { className: 'headerServicesTitle' }, lang.file.header.mrEstateMonetization.title),
                React.createElement("p", { className: 'sm:text-20 text-18 font-normal leading-7 mt-8 text-white whitespace-pre-wrap text-justify break-word' }, lang.file.header.mrEstateMonetization.text)));
        }
        else if (aboutUs) {
            return (React.createElement("p", { className: 'text-5xl font-bold text-white' }, lang.file.header.aboutUs.title));
        }
        return null;
    };
    return (React.createElement("div", { className: main }, labels()));
}
export default HeaderLabels;
